import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@sbd-doug-frontend/app/core/auth/auth.service';
import { User } from '@sbd-doug-frontend/app/core/user/user.types';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';

export interface ChangePasswordDialogConfig {
  dismissible?: boolean;
}

@Component({
  selector: 'sbd-doug-frontend-change-password',
  templateUrl: './change-password.component.html',
  standalone: false,
})
export class SharedChangePasswordComponent {
  @Input() teams: any;
  @Input() serviceCall: Function | undefined;
  @Input() pwObject: any;
  @Input() userId: number | undefined;
  @Input() pwConversion: any;
  @Input() requestMfaCode = false;
  @Input() loggedInUser: User | undefined;
  _cathy = inject(CathyService);
  _authService = inject(AuthService);
  canOpenDialog: boolean = true;

  constructor(public dialog: MatDialog) {
  }

  openDialog(): void {
    const config: ChangePasswordDialogConfig = {
      dismissible: true,
    };

    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      autoFocus: true,
      disableClose: !config.dismissible,
      data: {
        serviceCall: this.serviceCall,
        pwConversion: this.pwConversion,
        pwObject: this.pwObject,
        userId: this.userId,
        loggedInUser: this.loggedInUser,
        requestMfaCode: this.requestMfaCode,
      },
      panelClass: ['sm:w-full', 'sm:mx-5', 'md:w-600px'],
      width: '100%',
      height: 'auto',
      maxWidth: 'md:100%',
      maxHeight: 'sm:100vh',
      minHeight: '300px',
      minWidth: '300px',
    });
  }
}
